export const BRAND = {
  name: "Orchid Vue Spa",
  legalName: "Orchid Vue Massage Spa Center",
  tagline: "Sanctuary of Luxury & Serenity in Bur Dubai",
  phoneDisplay: "056 883 8765",
  callLink: "tel:+971568838765",
  whatsapp: "https://wa.me/971569830737",
  rating: "4.1",
  reviewCount: 54,
  address: "Orchid Vue Hotel, 8th Floor, Behind ADCB Bank, Bur Dubai, Dubai, UAE",
  landmark: "Near Sharaf DG & Al Fahidi Metro Stations",
  hours: "Open Daily · 10:00 AM – 12:00 AM · Walk-ins Welcome",
  instagram: "https://www.instagram.com/orchidvuespa",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Orchid+Vue+Hotel+Bur+Dubai",
  mapsEmbed:
    "https://maps.google.com/maps?q=Orchid%20Vue%20Hotel%2C%20Bur%20Dubai&t=&z=15&ie=UTF8&iwloc=&output=embed",
  reviewsUrl: "https://www.google.com/search?q=orchid+vue+spa+bur+dubai+reviews",
};

export const HOURS = {
  timeZone: "Asia/Dubai",
  open: 10,
  close: 24,
  openLabel: "10:00 AM",
};

export const waLink = (text) =>
  `${BRAND.whatsapp}?text=${encodeURIComponent(text)}`;

const local = (name) => `/assets/img/${name}.webp`;

export const IMAGES = {
  hero: local("hero"),
  orchid: local("orchid"),
  moroccan: local("moroccan"),
  couple: local("couple"),
  fourHand: local("fourhand"),
  deepTissue: local("deeptissue"),
  thai: local("thai"),
  aroma: local("aroma"),
};

export const SERVICES = [
  {
    slug: "royal-moroccan-bath",
    title: "Royal Moroccan Bath",
    duration: "60 / 90 min",
    desc: "Traditional black-soap exfoliation, herbal clay mask and deep steam therapy for luminous, renewed skin.",
    image: IMAGES.moroccan,
  },
  {
    slug: "couples-serenity-massage",
    title: "Couple's Serenity Massage",
    duration: "60 / 90 min",
    desc: "Side-by-side synchronized massage in our private luxury couple suite — the perfect shared escape.",
    image: IMAGES.couple,
  },
  {
    slug: "four-hand-harmony-massage",
    title: "Four-Hand Harmony Massage",
    duration: "60 min",
    desc: "Two therapists working in seamless rhythm to double the relief and melt deep muscular tension.",
    image: IMAGES.fourHand,
  },
  {
    slug: "deep-tissue-relax-massage",
    title: "Deep Tissue & Relax Massage",
    duration: "60 / 90 min",
    desc: "Tailored pressure targeting stubborn knots, chronic stiffness and every stress point that lingers.",
    image: IMAGES.deepTissue,
  },
  {
    slug: "traditional-thai-therapy",
    title: "Traditional Thai Stretch Therapy",
    duration: "60 / 90 min",
    desc: "Ancient rhythmic compression and gentle yoga stretches to restore energetic flow and flexibility.",
    image: IMAGES.thai,
  },
  {
    slug: "aromatherapy-organic-oils",
    title: "Aromatherapy Organic Oils",
    duration: "60 min",
    desc: "Custom-blended warm essential oils that calm the nervous system and invite profound sleep.",
    image: IMAGES.aroma,
  },
];

export const MARQUEE_ITEMS = [
  "Moroccan Bath",
  "Couple Massage",
  "Four-Hand Therapy",
  "Ladies Massage",
  "Aromatherapy Oils",
  "Thai Massage",
  "Sanitized Private Suites",
];

export const CHAPTERS = [
  {
    num: "01",
    title: "The 8th Floor Sanctuary",
    desc: "Perched on the top tier of Orchid Vue Hotel — high above the city noise, wrapped in candle-lit privacy.",
  },
  {
    num: "02",
    title: "Clinical Hygiene & Sanitation",
    desc: "Every private suite is fully sanitized after each guest, with fresh organic linens and sterilized equipment.",
  },
  {
    num: "03",
    title: "Certified Master Therapists",
    desc: "Skilled female and male therapists trained in authentic international techniques and deeply personalized care.",
  },
  {
    num: "04",
    title: "Effortless Bur Dubai Access",
    desc: "Steps from Sharaf DG & Al Fahidi Metro stations, with hotel parking and instant WhatsApp booking.",
  },
];

export const REVIEWS = [
  {
    name: "Ayesha K.",
    stars: 5,
    text: "Best Moroccan bath in Bur Dubai — the private suites are spotless and the therapists are true professionals.",
  },
  {
    name: "Mohammed R.",
    stars: 4,
    text: "Deep tissue massage fixed my back after months of stiffness. Two minutes from Sharaf DG metro.",
  },
  {
    name: "Elena S.",
    stars: 5,
    text: "Booked the couple's ritual for our anniversary. Beautiful, calm space on the 8th floor.",
  },
];

export const TIME_SLOTS = [
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
  "6:00 PM",
  "7:00 PM",
  "8:00 PM",
  "9:00 PM",
  "10:00 PM",
  "11:00 PM",
];
